import React from 'react';
import { Box } from '@chakra-ui/react';

const LoginCardContainer = ({ children }) => (
  <Box
    bg="white"
    maxW="lg"
    mx="auto"
    mt={{ base: 8, md: 16 }}
    p={{ base: 6, md: 8 }}
    borderRadius="2xl"
    boxShadow="2xl"
    w="full"
    position="relative"
    zIndex={2}
  >
    {children}
  </Box>
);

export default LoginCardContainer; 